import config from "appConfig";
import { LayoutComponent } from "@jelly/lesson";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [6, 2],
      gap: "15px",
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-end",
                maxHeight: "370px",
              },
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-01/principle/3-b-graph.png`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              styles: {
                alignItems: "flex-start",
                maxHeight: "90px",
              },
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/03/case-01/principle/3-b-table.png`,
                },
              },
            },
          },
        ],
      ],
    },
  },
};

export default component;
